import { useCallback } from "react";
import { useI18n } from "../i18n";
import { brokenRuleIds } from "../features/compliance/rules";
import { ApiError } from "./api";

/** Turns any failure into a sentence a person can read. Codes the UI does not know get the general message. */
export function useErrorMessage() {
  const { t, tCodeOrNull } = useI18n();
  return useCallback(
    (error: unknown): string => {
      const code = error instanceof ApiError ? error.code : "unknown";
      const message = tCodeOrNull("errors", code) ?? t("errors.unknown");
      // A refusal under the rules says which rules: without that, nobody knows what to change.
      const rules = error instanceof ApiError ? brokenRuleIds(error.details) : [];
      const reasons = [...new Set(rules.map((id) => tCodeOrNull("compliance.rule", id) ?? t("compliance.ruleOther")))];
      return [message, ...reasons].join(" ");
    },
    [t, tCodeOrNull],
  );
}
